
const actions = {
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  SET_DASHBOARD_DATA: 'SET_DASHBOARD_DATA',
  getDashboardData: () => ({
    type: actions.GET_DASHBOARD_DATA,
  }),
  setDashboardData: userData => ({
    type: actions.SET_DASHBOARD_DATA,
    userData
  }),

  JOIN_EXCELLENCE_PROGRAMME: 'JOIN_EXCELLENCE_PROGRAMME',
  JOIN_EXCELLENCE_PROGRAMME_SUCCEEDED: 'JOIN_EXCELLENCE_PROGRAMME_SUCCEEDED',
  JOIN_EXCELLENCE_PROGRAMME_FAILED: 'JOIN_EXCELLENCE_PROGRAMME_FAILED',
  joinExcellenceProgramme: () => ({
    type: actions.JOIN_EXCELLENCE_PROGRAMME,
  }),
  joinExcellenceProgrammeSucceeded: response => ({
    type: actions.JOIN_EXCELLENCE_PROGRAMME_SUCCEEDED,
    payload: response,
  }),
  joinExcellenceProgrammeFailed: response => ({
    type: actions.JOIN_EXCELLENCE_PROGRAMME_FAILED,
    payload: response,
  })
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/dashboard/actions.js